export const environment = {
  production: false,
  baseUrl: 'https://awmt.qalbs.com/',
  reportServerUrl:'https://awmt.qalbs.com/',
  CORPORATE_PANEL_URL: "concierge.transmedik.com/",
  TRACKING_URL: "https://membercaredev.nemtplatform.com/trip-tracking/",
  PROVIDER_PANEL_URL: "https://awmt.transmedik.com/",
};
